import { useState } from 'react'

// local
import { IFilteredCoiffeurList } from 'types/CoiffeurType'

export default function useCoiffeurReservationModal() {
  const [selectedCoiffeur, setSelectedCoiffeur] = useState<IFilteredCoiffeurList | undefined>()
  const [reservationModal, setReservationModal] = useState(false)
  const [notification, setNotification] = useState(false)

  const closeReservationModal = () => setReservationModal(false)
  const openReservationModal = (coiffeur?: IFilteredCoiffeurList) => {
    setReservationModal(true)
    if (coiffeur) setSelectedCoiffeur(coiffeur)
  }

  return {
    selectedCoiffeur,
    setSelectedCoiffeur,
    reservationModal,
    openReservationModal,
    closeReservationModal,
    notification,
    setNotification,
  }
}
